import { CSSObject } from "@emotion/react";

export const loadingSpinnerCss: CSSObject = {
  marginBottom: "24px",
};
